import React from "react";
import { RotateCcw } from "lucide-react";

export default function EmptyDeck({ onReset }) {
    return (
        <div
            data-testid="empty-deck"
            className="absolute inset-0 flex flex-col items-center justify-center text-center px-8"
        >
            <div className="font-display text-5xl uppercase text-white/20 mb-3">
                The End
            </div>
            <p className="text-white/60 mb-8 max-w-xs">
                You've seen every piece in the drop. Check back soon for more
                KYLIE WEST.
            </p>
            <button
                data-testid="reset-deck-btn"
                onClick={onReset}
                className="flex items-center gap-2 px-6 py-3 rounded-full border border-white/20 hover:border-[#FF5A00] hover:text-[#FF5A00] transition-colors text-white/80"
            >
                <RotateCcw size={16} /> Swipe again
            </button>
        </div>
    );
}
